import { api } from "../configs/apiConfig";

const userPreferenceService = {
    getUserPreference: async (userId) => {
        try {
            const response = await api.get(`/UserPreference/${userId}`);
            return response.data;
        } catch (error) {
            console.error("Failed to get user preferences:", error.response?.data || error.message);
            throw error;
        }
    },

    saveUserPreference: async (userId, data) => {
        try {
            // Convert data to FormData if it's not already
            const formData = data instanceof FormData ? data : new FormData();
            
            // If data is not FormData, append all fields
            if (!(data instanceof FormData)) {
                if (data.darkMode !== undefined) formData.append('darkMode', data.darkMode);
                if (data.twoFactorMethod !== undefined) formData.append('twoFactorMethod', data.twoFactorMethod);
                if (data.formOpacity !== undefined) formData.append('formOpacity', data.formOpacity);
                if (data.formBlur !== undefined) formData.append('formBlur', data.formBlur);
                if (data.backgroundBlur !== undefined) formData.append('backgroundBlur', data.backgroundBlur);
                if (data.baseColor) formData.append('baseColor', data.baseColor);
                if (data.backgroundImage) formData.append('backgroundImage', data.backgroundImage);
                if (data.backgroundImagePath) formData.append('backgroundImagePath', data.backgroundImagePath);
            }

            const response = await api.put(`/UserPreference/${userId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            return response.data;
        } catch (error) {
            console.error("Failed to save user preferences:", error.response?.data || error.message);
            throw error;
        }
    },

    deleteUserPreference: async (userId) => {
        try {
            await api.delete(`/UserPreference/${userId}`);
        } catch (error) {
            console.error("Failed to delete user preferences:", error.response?.data || error.message);
            throw error;
        }
    }
};

export default userPreferenceService; 